import { useTranslation } from 'react-i18next';
import { useConsent } from '../ConsentProvider';
import styles from './CookieConsent.module.css';

interface CookieConsentBannerProps {
  onCustomize: () => void;
}

export function CookieConsentBanner({ onCustomize }: CookieConsentBannerProps) {
  const { t } = useTranslation();
  const { acceptAll, rejectAll } = useConsent();

  return (
    <div className={styles.banner}>
      <div className={styles.banner__inner}>
        <div className={styles.banner__text}>
          <h3 className={styles.banner__title}>{t('consent.title')}</h3>
          <p className={styles.banner__description}>
            {t('consent.description')}
          </p>
        </div>
        <div className={styles.banner__actions}>
          <button
            type="button"
            className={styles['banner__btn--primary']}
            onClick={acceptAll}
          >
            {t('consent.acceptAll')}
          </button>
          <button
            type="button"
            className={styles.banner__btn}
            onClick={rejectAll}
          >
            {t('consent.rejectAll')}
          </button>
          <button
            type="button"
            className={styles['banner__btn--outline']}
            onClick={onCustomize}
          >
            {t('consent.customize')}
          </button>
        </div>
      </div>
    </div>
  );
}
